import DVCore from "./core/DVCore";

const AdminMyAppsAPI = {};

AdminMyAppsAPI.baseURL = "/api/admin/myapps/";

AdminMyAppsAPI.list = (status, onSuccess, onFail, onError = null) => {
    const params = status ? { status } : null;
    return DVCore.get(AdminMyAppsAPI.baseURL, params, onSuccess, onFail, onError);
};

AdminMyAppsAPI.get = (appId, onSuccess, onFail, onError = null) => {
    return DVCore.get(AdminMyAppsAPI.baseURL + appId, null, onSuccess, onFail, onError);
};

AdminMyAppsAPI.approve = (appId, onSuccess, onFail, onError = null) => {
    return DVCore.post(AdminMyAppsAPI.baseURL + appId + "/approve", {}, onSuccess, onFail, onError);
};

AdminMyAppsAPI.reject = (appId, reason, onSuccess, onFail, onError = null) => {
    return DVCore.post(AdminMyAppsAPI.baseURL + appId + "/reject", { reason }, onSuccess, onFail, onError);
};

export default AdminMyAppsAPI;
